<template>
  <div
    :class="{ 'condition-group': !group?.first }"
    v-if="group !== undefined"
  >
    <div class="input-group">
      <label>Visible if </label>
      <select v-model="group.operator">
        <option value="AND">all of those are true (AND)</option>
        <option value="OR">one of those are true (OR)</option>
      </select>
    </div>
    <div
      v-for="(item, index) in group.conditions"
      :key="index"
      class="condition-item"
    >
      <condition-editor
        v-if="item.type === 'condition'"
        v-model="group.conditions[index]"
        :variables="variables"
      />
      <condition-group-editor
        v-else
        v-model="group.conditions[index]"
        :variables="variables"
      />
      <button @click="removeCondition(index)">Remove</button>
    </div>

    <button @click="addCondition">
      Add Condition
    </button>
    <button @click="addGroup">Add Group</button>
  </div>
</template>

<script>
import ConditionEditor from "./ConditionEditor.vue";
import ConditionGroupEditor from "./ConditionGroupEditor.vue";

export default {
  name: "ConditionGroupEditor",
  components: { ConditionEditor, ConditionGroupEditor },
  props: ["variables", "modelValue"],
  computed: {
    group: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit("update:modelValue", val);
      },
    },
  },
  watch: {
    modelValue: {
      immediate: true,
      handler(val) {
        if (!val) {
          this.$emit("update:modelValue", {
            type: "group",
            first: true,
            operator: "AND",
            conditions: [],
          });
        }
      },
    },
  },
  methods: {
    addCondition() {
      this.group.conditions.push({
        type: "condition",
        variable: "",
        operator: "==",
        value: "",
      });
    },
    addGroup() {
      this.group.conditions.push({
        type: "group",
        operator: "AND",
        conditions: [
          {
            type: "condition",
            variable: "",
            operator: "==",
            value: "",
          },
        ],
      });
    },
    removeCondition(index) {
      this.group.conditions.splice(index, 1);
    },
  },
};
</script>
